import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessProjectOnboadingScreens } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canManageProjectManagement } from "@/helpers/permissions";

import { onboardingScreensRoutes } from "./routes";

export const onboardingScreensRoute = [
  {
    path: onboardingScreensRoutes.list,
    lazy: async () => {
      const { OnboardingScreenOverviewPage } = await import("./pages/list/OnboardingScreenOverviewPage");

      return {
        element: (
          <RequireAuth permission={canAccessProjectOnboadingScreens}>
            <OnboardingScreenOverviewPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: onboardingScreensRoutes.new,
    lazy: async () => {
      const { CreateOnboardingScreenPage } =
        await import("./pages/onboarding-screen-editor/CreateOnboardingScreenPage");

      return {
        element: (
          <RequireAuth permission={canManageProjectManagement}>
            <CreateOnboardingScreenPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: onboardingScreensRoutes.edit,
    lazy: async () => {
      const { EditOnboardingScreenPage } = await import("./pages/onboarding-screen-editor/EditOnboardingScreenPage");

      return {
        element: (
          <RequireAuth permission={canManageProjectManagement}>
            <EditOnboardingScreenPage />
          </RequireAuth>
        ),
      };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
